import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import $api from '../api'

export interface PlaylistHistoryPlaylist {
  _id: string
  title: string
  image: string
  viewCount?: number
  songsCount?: number
  totalDuration?: number
  updatedAt?: string
}

export interface PlaylistHistoryItem {
  listenedAt: number
  playlist: PlaylistHistoryPlaylist
}

interface State {
  items: PlaylistHistoryItem[]
  isLoading: boolean
  isTouching: boolean
  error: string | null
}

export const initialState: State = {
  items: [],
  isLoading: false,
  isTouching: false,
  error: null,
}

export const attemptGetPlaylistHistory = createAsyncThunk<
  PlaylistHistoryItem[],
  number | undefined
>('playlist-history/list', async (limit = 20) => {
  const response = await $api.post('playlist-history/user/list', { limit })
  return response.data
})

export const attemptTouchPlaylistHistory = createAsyncThunk<{ success: boolean }, string>(
  'playlist-history/touch',
  async (playlistId) => {
    const response = await $api.post(`playlist-history/touch/${playlistId}`)
    return response.data
  },
)

const playlistHistorySlice = createSlice({
  name: 'playlistHistory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(attemptGetPlaylistHistory.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(attemptGetPlaylistHistory.fulfilled, (state, { payload }) => {
        state.isLoading = false
        state.items = payload
      })
      .addCase(attemptGetPlaylistHistory.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message || 'Failed to load playlist history'
      })

      .addCase(attemptTouchPlaylistHistory.pending, (state) => {
        state.isTouching = true
      })
      .addCase(attemptTouchPlaylistHistory.fulfilled, (state) => {
        state.isTouching = false
      })
      .addCase(attemptTouchPlaylistHistory.rejected, (state, action) => {
        state.isTouching = false
        state.error = action.error.message || 'Failed to touch playlist history'
      })
  },
})

export default playlistHistorySlice.reducer
